import { render, staticRenderFns } from "./reporting-integration-app.vue?vue&type=template&id=00c545ce"
import script from "./reporting-integration-app.vue?vue&type=script&lang=js"
export * from "./reporting-integration-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports